<script>
export default {
  name: 'ExcelLogoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#185C37',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando o gradiente nas instâncias duplicadas.
    paintId() {
      return `paint0_linear_1_2_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 11.8167L6 10.2667V21.7196C6 22.2427 6.41033 22.6667 6.9165 22.6667H21.5835C22.0897 22.6667 22.5 22.2427 22.5 21.7196V17.5L14.5 11.8167Z"
      fill="#185C37"
    />
    <path
      d="M14.5 2H6.9165C6.41033 2 6 2.42401 6 2.94705V7.16667L14.5 12.3333L19 13.8833L22.5 12.3333V7.16667L14.5 2Z"
      fill="#21A366"
    />
    <path d="M6 7.16667H14.5V12.3333H6V7.16667Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M12.0835 6.13333H6V19.05H12.0835C12.589 19.0483 12.9984 18.6253 13 18.103V7.08038C12.9984 6.55805 12.589 6.13503 12.0835 6.13333Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M11.5835 6.65H6V19.5667H11.5835C12.089 19.565 12.4984 19.142 12.5 18.6196V7.59705C12.4984 7.07471 12.089 6.6517 11.5835 6.65Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M11.5835 6.65H6V18.5333H11.5835C12.089 18.5316 12.4984 18.1086 12.5 17.5863V7.59705C12.4984 7.07471 12.089 6.6517 11.5835 6.65Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M11.0835 6.65H6V18.5333H11.0835C11.589 18.5316 11.9984 18.1086 12 17.5863V7.59705C11.9984 7.07471 11.589 6.6517 11.0835 6.65Z"
      fill="black"
    />
    <path
      d="M1.9165 6.65H11.0835C11.5897 6.65 12 7.074 12 7.59705V17.0696C12 17.5926 11.5897 18.0167 11.0835 18.0167H1.9165C1.41033 18.0167 1 17.5927 1 17.0696V7.59705C1 7.074 1.41033 6.65 1.9165 6.65Z"
      :fill="`url(#${paintId})`"
    />
    <path
      d="M3.8385 15.4116L5.7665 12.3246L4 9.25451H5.42099L6.385 11.2178C6.474 11.4044 6.535 11.5428 6.568 11.6343H6.5805C6.64281 11.4877 6.70951 11.3431 6.7805 11.2008L7.81099 9.25555H9.11549L7.30399 12.3075L9.1615 15.4116H7.7735L6.66 13.2566C6.60755 13.1649 6.56304 13.0686 6.527 12.9688H6.51051C6.47789 13.0666 6.43461 13.1602 6.3815 13.2478L5.235 15.4116H3.8385Z"
      fill="white"
    />
    <path
      d="M21.5835 2H14.5V7.16667H22.5V2.94705C22.5 2.42401 22.0897 2 21.5835 2Z"
      fill="#33C481"
    />
    <path d="M14.5 12.3333H22.5V17.5H14.5V12.3333Z" fill="#107C41" />
    <defs>
      <linearGradient
        :id="paintId"
        x1="2.91092"
        y1="5.91"
        x2="10.4479"
        y2="18.5426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#18884F" />
        <stop offset="0.5" stop-color="#117E43" />
        <stop offset="1" stop-color="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
</template>
